import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

const QnA = () => {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [service, setService] = useState<string>("");
  const [contents, setContents] = useState<string>("");

  const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name || !phone || !contents) {
      Swal.fire({
        title: "이름, 연락처, 문의내용을을 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    setLoading(true);

    await axios
      .post("/api/contact", {
        name: name,
        phone: phone,
        service: service,
        type: 2,
        contents: contents,
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };

  return (
    <div
      id="qna"
      className=" relative w-full h-full px-[calc((100%-var(--container))/2)] 3xl:px-[calc((100%-var(--container)-100px))] py-8 lg:py-16 2xl:py-32"
    >
      <p className="text-[#9E9E9E] mb-10 lg:mb-16">
        04. Q & A (000이 궁금해요!)
      </p>
      <div className=" relative w-full h-fit mb-10 lg:mb-5">
        <p>도어락 · 열쇠 문제에 관한 다양한 질문들을 편하게 문의해주세요</p>
        <h3 className="font-light text-black">
          문자접수를 통해 질문을 확인하고 답변드립니다.
        </h3>
        <small className="text-[#ff0000]">
          ( 장난문의 시 경우에 따라 법적인 조치를 취할 수 있습니다 )
        </small>
      </div>
      <div className=" relative w-full h-full bg-white rounded-3xl py-10 px-5 lg:px-10">
        <div className=" absolute right-5 lg:right-16 -top-8 lg:-top-24 w-fit h-fit">
          <img
            className="!relative w-28 lg:w-56 h-auto object-contain"
            src="/images/iconQna.png"
            alt="icon"
            width={339}
            height={247}
          />
        </div>
        <div className=" border-l-4 border-primary pl-4 lg:pl-6 text-black my-4">
          <p className="gmedium lg:text-xl font-black">
            이런것도 해결이 가능할까? 하는 질문부터
          </p>
          <p className="gmedium lg:text-xl font-black my-1">
            이런상황이 생겼는데 어떻게 해야할까요? 같은 질문들까지
          </p>
          <p className="gmedium lg:text-xl font-black text-[var(--gray-color)]">
            <span className="text-primary">SOS도어락열쇠프로</span>는 성심성의껏
            답변드리며 필요한 경우 해결해드립니다.
          </p>
        </div>
        <div className=" relative mt-10 w-full h-full max-w-screen-xl grid grid-cols-2 xs:grid-cols-3 gap-5 2xl:px-10">
          <div className="col-span-2 xs:col-span-3 relative w-full h-full max-w-screen-lg grid grid-cols-2 gap-2 lg:gap-5 mb-5">
            <div className=" relative w-full h-full">
              <label htmlFor="name1" className="lg:text-xl">
                이름&nbsp;<span className="text-[var(--red-color)]">*</span>
              </label>
              <input
                type="text"
                placeholder="이름을 입력해주세요"
                value={name}
                id="name1"
                name="name1"
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className=" relative w-full h-full">
              <label htmlFor="phone1" className="lg:text-xl">
                연락처&nbsp;<span className="text-[var(--red-color)]">*</span>
              </label>
              <input
                type="text"
                placeholder="연락처를 입력해주세요"
                value={phone}
                id="phone1"
                name="phone1"
                onChange={(e) =>
                  setPhone(
                    e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*)\./g, "$1")
                  )
                }
              />
            </div>
            <div className="col-span-2 lg:col-span-1 relative w-full h-full">
              <label htmlFor="service2" className="lg:text-xl">
                문의종류
              </label>
              <select
                name="service2"
                id="service2"
                onChange={(e) => setService(e.target.value)}
              >
                <option value="">서비스 목록</option>
                <option value="도어락 관련 서비스">도어락 관련 서비스</option>
                <option value="열쇠 관련 서비스">열쇠 관련 서비스</option>
              </select>
            </div>
          </div>

          <div className="col-span-2 xs:col-span-3 relative w-full h-full">
            <button
              type="button"
              onClick={handlerPostContact}
              disabled={loading}
              // onClick={() => window.alert("준비중입니다.")}
              className="absolute right-0 -top-6 w-fit h-fit pt-1 px-5 bg-point border border-black rounded-xl z-30"
            >
              <h4 className="font-light text-shadow">전송</h4>
            </button>
            <label htmlFor="contents" className="lg:text-xl">
              질문 내용
            </label>
            <textarea
              className="!h-32"
              placeholder="내용을 입력해주세요"
              value={contents}
              name="contents"
              id="contents"
              onChange={(e) => setContents(e.target.value)}
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QnA;
